import { render, staticRenderFns } from "./IngredientCombo.vue?vue&type=template&id=6ff624fe&scoped=true"
import script from "./IngredientCombo.vue?vue&type=script&lang=js"
export * from "./IngredientCombo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ff624fe",
  null
  
)

export default component.exports